import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import { GiHamburgerMenu } from 'react-icons/gi'
import { CgCloseR } from 'react-icons/cg'
import { useLocation } from 'react-router-dom'
import logo from '../images/logo.png'

const Header = () => {
  const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 768)
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef()
  const location = useLocation()

  // makes sure page starts at top when a new page is visited on mobile nav
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  useEffect(() => {
    const handleResize = () => {
      setIsMediumScreen(window.innerWidth > 900) /*was 768*/
    }

    const handleOutsideClick = (event) => {
      if (
        isOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }

    window.addEventListener('resize', handleResize)
    document.addEventListener('click', handleOutsideClick)

    return () => {
      window.removeEventListener('resize', handleResize)
      document.removeEventListener('click', handleOutsideClick)
    }
  }, [isOpen])

  const handleHamburgerClick = (e) => {
    e.stopPropagation()
    setIsOpen(!isOpen)
  }

  return (
    <>
      {isMediumScreen ? (
        <header className="bg-emerald-700 p-6">
          <nav className="text-black flex justify-between items-center">
            <div className="block">
              <h1 className="font-oleo text-3xl tracking-wide text-white">
                The Asheville Mountain Boys
              </h1>
              {/* <img src={logo} alt="band name logo" className="h-40 w-auto" /> */}
            </div>
            <div className="space-x-8 font-bold">
              <Link
                className="hover:text-gray-100 duration-500"
                to="/home"
                onClick={() => setIsOpen(!isOpen)}
              >
                Home
              </Link>
              <Link
                className="hover:text-gray-100 duration-500"
                to="/press"
                onClick={() => setIsOpen(!isOpen)}
              >
                EPK
              </Link>
              {/* <Link
                className="hover:text-gray-100 duration-500"
                to="/tour"
                onClick={() => setIsOpen(!isOpen)}
              >
                Tour
              </Link> */}
              <Link
                className="hover:text-gray-100 duration-500"
                to="https://ashevillemountainboys.bandcamp.com/merch"
                onClick={() => setIsOpen(!isOpen)}
                target="_blank"
              >
                Store
              </Link>
              <Link
                className="hover:text-gray-100 duration-500"
                to="/media"
                onClick={() => setIsOpen(!isOpen)}
              >
                Media
              </Link>
              <Link
                className="hover:text-gray-100 duration-500"
                to="/bio"
                onClick={() => setIsOpen(!isOpen)}
              >
                Bio
              </Link>
              <Link
                className="hover:text-gray-100 duration-500"
                to="/tour"
                onClick={() => setIsOpen(!isOpen)}
              >
                Tour
              </Link>
              <Link
                className="hover:text-gray-100 duration-500"
                to="/contact"
                onClick={() => setIsOpen(!isOpen)}
              >
                Contact
              </Link>
            </div>
          </nav>
        </header>
      ) : (
        <div className="fixed top-0 left-0 w-full z-10 ">
          <nav className="bg-emerald-700 p-6 text-white flex items-center justify-between ">
            <div className="flex items-center">
              {isOpen ? (
                <CgCloseR
                  className="cursor-pointer text-gray-200 hover:text-slate-50  duration-500"
                  style={{ width: '1.5rem', height: '1.5rem' }}
                />
              ) : (
                <GiHamburgerMenu
                  style={{ width: '1.5rem', height: '1.5rem' }}
                  onClick={handleHamburgerClick}
                  className="cursor-pointer text-gray-200  hover:text-slate-50  duration-500 "
                ></GiHamburgerMenu>
              )}

              <h1 className=" font-oleo text-2xl tracking-wide ml-4">
                The Asheville Mountain Boys
              </h1>
            </div>
          </nav>
          {isOpen && (
            <div
              ref={menuRef}
              className="tracking-widest absolute left-0 bg-emerald-700 flex flex-col z-20 p-12 rounded-br-xl text-xl  h-screen text-slate-50 opacity-80 font-bold"
            >
              <Link
                className="hover:text-slate-400 duration-500 mb-3  "
                to="/home"
                onClick={() => setIsOpen(!isOpen)}
              >
                Home
              </Link>
              <Link
                className="hover:text-slate-400 duration-500 mb-3"
                to="/press"
                onClick={() => setIsOpen(!isOpen)}
              >
                EPK
              </Link>
              {/* <Link
                className="hover:text-slate-400 duration-500 mb-3"
                to="/tour"
                onClick={() => setIsOpen(!isOpen)}
              >
                Tour
              </Link> */}
              <Link
                className="hover:text-slate-400 duration-500 mb-3"
                to="https://ashevillemountainboys.bandcamp.com/merch"
                onClick={() => setIsOpen(!isOpen)}
                target="_blank"
              >
                Store
              </Link>
              <Link
                className="hover:text-slate-400 duration-500 mb-3"
                to="/media"
                onClick={() => setIsOpen(!isOpen)}
              >
                Media
              </Link>
              <Link
                className="hover:text-slate-400 duration-500 mb-3"
                to="/bio"
                onClick={() => setIsOpen(!isOpen)}
              >
                Bio
              </Link>
              <Link
                className="hover:text-slate-400 duration-500 mb-3"
                to="/Tour"
                onClick={() => setIsOpen(!isOpen)}
              >
                Tour
              </Link>
              <Link
                className="hover:text-slate-400 duration-500"
                to="/contact"
                onClick={() => setIsOpen(!isOpen)}
              >
                Contact
              </Link>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default Header
